import { COLLATE_DATA_MANAGER } from '../../data/manager/collatedatamng';
import { PAIPAN } from '../../data/core/paipan';
import { CALENDAR_DATA_MANAGER } from '../../data';
import { MOMENT_TIME } from '../../momenttime';
import { API_JSON } from '../../api';
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        detailFromPage: 'calendar',
        todayInfo: {},
        calendarInfo: {},
        currentTab: 1,
        showCalendarYearPop: false,
        showCalendarDatePop: false,
        currentCalendarDate: null,
        currentCalendarDateArr: [],
        calendarJieQiList: [],
        calendarYearList: [],
        calendarYear: 0,
        calendarYearIndex: 0,
        gotYiJiJsonData: {},
        curYiJiData: {},
        showCalendarHourPop: false,
        calendarHourList: [],
        curCalendarHour: {},
        calendarFormData: {},
        showCalendarChagnePop: false
    },
    getters: {},
    mutations: {},
    actions: {
        initTodayInfo({ state }) {
            state.todayInfo = COLLATE_DATA_MANAGER.getTodayCalendarInfoData();
        },
        initCalendarData({ dispatch, state }) {
            if(!state.currentCalendarDate) {
                state.currentCalendarDate = new Date();
            }
            state.calendarYear = state.currentCalendarDate.getFullYear();
            console.log('initCalendarData-------', state.currentCalendarDate, state.calendarYear)
            dispatch('initCalendarInfoData');
            dispatch('initCalendarYiJiData');
        },
        initCalendarInfoData({ state }) {
            state.calendarInfo = CALENDAR_DATA_MANAGER.getCalendarInfoDataByDate(state.currentCalendarDate);
            console.log('initCalendarInfoData--------', state.calendarInfo)
        },
        initCalendarYiJiData({ state, rootGetters }) {
            // 处理宜忌数据
            var dateArr = MOMENT_TIME.getTimeArrayByTimeStamp(state.currentCalendarDate),
                year = dateArr.length > 0 ? dateArr[0] : null,
                month = dateArr.length > 0 ? dateArr[1] : null,
                day = dateArr.length > 0 ? dateArr[2] : null,
                dateStr = year + '-' + UTILS.getTimeStrByInt(month) + '-' + UTILS.getTimeStrByInt(day),
                configYiJiJsonData = rootGetters['configYiJiJsonData'],
                configYiJiList = configYiJiJsonData ? configYiJiJsonData.url : [];
            var curUrl = _.filter(configYiJiList, (data => data.indexOf(year) != -1));
                curUrl = curUrl.length > 0 ? curUrl[0] : '';
            console.log('initCalendarYiJiData-----', state.currentCalendarDate, dateStr, curUrl);
            // 如果没有获取当前json，就从网上下载
            state.curYiJiData = {};
            if(curUrl != '' && !state.gotYiJiJsonData[year]){
                API_JSON.getJSon(curUrl, function(data) {
                    state.gotYiJiJsonData[year] = data;
                    state.curYiJiData = state.gotYiJiJsonData[year][dateStr];
                }, function() {
                    state.curYiJiData = {};
                });
            }else if(state.gotYiJiJsonData[year]) {
                state.curYiJiData = Object.assign({}, state.gotYiJiJsonData[year][dateStr]);
            }
        },
        initCalendarDatePop({ state }, params) {
            state.showCalendarDatePop = true;
            state.currentCalendarDate = new Date(params.year, params.month, params.day);
        },
        initCalendarYearPop({ state }) {
            state.calendarYear = state.currentCalendarDate.getFullYear();
            var length = 200, start = state.calendarYear - 100;
            state.calendarYearList = Array.apply(null,{length: length}).map(function(){ start++; return start; });
            state.calendarYearIndex = state.calendarYearList.indexOf(state.calendarYear);
            state.showCalendarYearPop = true;
        },
        initCalendarJieQi({state}, year) {
            state.calendarYear = year;
            var month = state.currentCalendarDate.getMonth(),
                day = state.currentCalendarDate.getDate();
                state.currentCalendarDate = new Date(year, month, day);
            var yueList = PAIPAN.getLiuYueNew(year);
            state.calendarJieQiList = CALENDAR_DATA_MANAGER.getCalendarJieQiListByList(yueList);
            console.log('initCalendarJieQi-------', state.calendarJieQiList)
        },
        initCalendarHour({state}) {
            state.showCalendarHourPop = true;
            state.curCalendarHour = {};
            state.calendarHourList = [];
            state.calendarHourList = CALENDAR_DATA_MANAGER.getCalendarHourArrayByRigan(state.calendarInfo.rigan);
        },
        updateCalendarHour({state}, data) {
            state.calendarInfo.sizhu[3].gan = data.gan;
            state.calendarInfo.sizhu[3].zhi = data.zhi;
            state.curCalendarHour = data;
            state.calendarHourList = CALENDAR_DATA_MANAGER.updateCalendarHourArrayChoosedStatus(state.calendarHourList, data);
        },
        startCalendarCollate({dispatch, state}, params) {
            if(!state.currentCalendarDate) {
                state.currentCalendarDate = new Date();
            }
            var now = MOMENT_TIME.getTimeArrayByTimeStamp(),
                year = state.currentCalendarDate.getFullYear(),
                month = state.currentCalendarDate.getMonth()+1,
                day = state.currentCalendarDate.getDate(),
                hour = state.curCalendarHour && state.curCalendarHour.begTime ? parseInt(state.curCalendarHour.begTime) : now[3],
                dateStr = year + '-' + UTILS.getTimeStrByInt(month) + '-' + UTILS.getTimeStrByInt(day) + ' ' + UTILS.getTimeStrByInt(hour) + ':00:00';
            state.calendarFormData = {
                birthday: dateStr, 
                f_group: 0, 
                f_name: "未命名", 
                label: "", 
                location: "", 
                real_time: "", 
                remark: "", 
                sex: 0, 
                unknown: 0,
                zwzs: parseInt(AppFate.$store.state.setting.settingConfigData.zaoWanZiShi)
            }
            console.log('startCalendarCollate------', state.calendarFormData)
            dispatch('detail/initLocalDetail', {
                formData: state.calendarFormData,
                cb: params.cb
            }, {root: true});
        },
        updateCalendarFormData({state}, data) {
            console.error('updateCalendarFormData-------', data)
            state.calendarFormData.group = data.f_name;
            state.calendarFormData.f_group = data.id;
        },
        saveCalendarCollate({dispatch, state}, params) {
            var formData = Object.assign({}, state.calendarFormData);
                formData = _.omit(formData, ['group']);
            dispatch('collate/submitCollate', {
                formData: formData,
                cb: params.cb
            }, {root: true});
        }
    }
}